import { Directive, Input } from "@angular/core";
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  Validators,
  ControlContainer
} from "@angular/forms";
import * as moment from "moment";

@Directive({
  selector: "[dateRange]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DateRangeValidatorDirective,
      multi: true
    }
  ]
})
export class DateRangeValidatorDirective implements Validator {
  @Input("dateRange") range: { start: string; end: string };
  private valFn = Validators.nullValidator;

  constructor() {
    this.valFn = (group: any) => {
      if (
        group &&
        group.controls[this.range.start] &&
        group.controls[this.range.end] &&
        typeof group.controls[this.range.start].value !== "undefined" &&
        typeof group.controls[this.range.end].value !== "undefined"
      ) {
        return moment(group.controls[this.range.start].value).isValid() &&
          moment(group.controls[this.range.end].value).isValid() &&
          moment(group.controls[this.range.end].value).isSameOrAfter(
            moment(group.controls[this.range.start].value)
          )
          ? null
          : {
              dateRange: {
                start: group.controls[this.range.start].value,
                end: group.controls[this.range.end].value
              }
            };
      }
      return null;
    };
  }

  validate(control: AbstractControl): { [key: string]: any } {
    return this.valFn(control);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/daterangevalidator.directive.ts